// extracted by mini-css-extract-plugin
export default {"time":"Time_time__kHnzC","active":"Time_active__+4a9-"};